import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ChevronRight, LogOut } from "lucide-react";
import "./Header.css";

const LABELS = {
  admin: "Admin",
  dashboard: "Dashboard",
  properties: "Properties",
  cities: "Cities",
  developers: "Developers",
  amenities: "Amenities",
  projects: "Projects",
  new: "New",
  edit: "Edit",
};

export default function Header() {
  const location = useLocation();
  const navigate = useNavigate();

  // Path after /admin  e.g. /admin/properties/edit → ["properties", "edit"]
  const parts = location.pathname
    .split("/")
    .filter(Boolean)
    .slice(1); // drop "admin"

  // const handleLogout = () => {
  //   localStorage.removeItem("isAuthenticated");
  //   navigate("/admin");
  // };

  return (
    <header className="hd">
      {/* Breadcrumb */}
      <div className="hd-crumb">
        <span className="hd-crumb-root">Admin</span>
        {parts.map((p, i) => (
          <span key={i} className="hd-crumb-part">
            <ChevronRight className="hd-chevron" />
            {i === parts.length - 1 ? (
              <strong>{LABELS[p] ?? p}</strong>
            ) : (
              <span>{LABELS[p] ?? p}</span>
            )}
          </span>
        ))}
      </div>

      {/* Right side */}
      <div className="hd-right">
        <div className="hd-user">
          <div className="hd-mail">Administrator</div>
          <div className="hd-role">Admin panel</div>
        </div>

        <div className="hd-avatar">A</div>

        {/* <button
          type="button"
          onClick={handleLogout}
          className="hd-logout"
          title="Logout"
        >
          <LogOut className="h-4 w-4" />
          <span>Logout</span>
        </button> */}
      </div>
    </header>
  );
}